/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

// this is autogenerated file, see scripts/version-update.js
export const VERSION = '2.12.0';
